// File: /college000/frontend/redux/attendanceRelated/attendanceSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { markAttendance } from './attendanceHandle';

const attendanceSlice = createSlice({
    name: 'attendance',
    initialState: {
        loading: false,
        attendanceData: null,
        error: null,
    },
    reducers: {
        resetAttendanceState: (state) => {
            state.loading = false;
            state.attendanceData = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(markAttendance.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(markAttendance.fulfilled, (state, action) => {
                state.loading = false;
                state.attendanceData = action.payload;
                state.error = null;
            })
            .addCase(markAttendance.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to mark attendance';
            });
    },
});

export const { resetAttendanceState } = attendanceSlice.actions;
export default attendanceSlice.reducer;
